define(["require", "exports", "jquery", "knockout", "log", "../../utils/urls", "../../utils/tools", "../../utils/kendoUtils", "../../shared/dataLogs", "../../models/ServerGroupModel", "../../models/ServerModel", "../../models/UserContext", "./serverActions"], function (require, exports, $, ko, log, urls_1, tools, KendoUtils, DataLogs, ServerGroupModel, ServerModel, UserContext, ServerActions) {
    "use strict";
    var ServersGroups = /** @class */ (function () {
        function ServersGroups() {
            this.editModel = ko.observable(new ServerGroupModel());
            this.editServerModel = ko.observable(new ServerModel());
            this.serverActions = new ServerActions();
            this.clearFilterInProgress = false;
            this.filterByAny = ko.observable("");
            this.expandedItemIDs = [];
        }
        ServersGroups.prototype.init = function () {
            var self = this;
            $("#page-title").text("Server Groups");
            tools.ajaxGet({
                url: "/ServersGroups/GetLookupData",
                success: function (data) {
                    if (data.Success) {
                        self.lookupLists = data.Data.lookupLists;
                        self.initGroupTableColumns();
                        self.initServerTableColumns();
                        self.initGroups();
                        ko.applyBindings(self, document.getElementById("main-container"));
                        $("#contextLoader").hide();
                        $("#mainContext").show();
                    }
                    else {
                        log.error(data.Error);
                    }
                }
            });
        };
        ServersGroups.prototype.initGroupTableColumns = function () {
            var self = this;
            var gridStructure = self.lookupLists.GridStructures.ServerGroupStructure;
            var columns = gridStructure.columns;
            columns.push({
                field: "",
                title: "",
                width: "240px",
                sortable: false,
                template: function (dataItem) {
                    var html = "";
                    if (dataItem.Id !== 1) {
                        html += '<a class="btn btn-sm btn-info btn-edit" href="#"><i class="fa fa-edit "></i>&nbsp;Edit</a>';
                        html += '&nbsp;<a class="btn btn-sm btn-info btn-add" href="#"><i class="fa fa-link "></i>&nbsp;Link</a>';
                        html += '&nbsp;<button class="btn btn-sm btn-danger btn-remove" href="#"><i class="fa fa-trash-o "></i>&nbsp;Delete</button>';
                    }
                    return html;
                }
            });
        };
        ServersGroups.prototype.initServerTableColumns = function () {
            var self = this;
            var gridStructure = self.lookupLists.GridStructures.ServersStructure;
            var columns = gridStructure.columns;
            columns.push({
                field: "",
                title: "",
                width: "330px",
                sortable: false,
                template: function (dataItem) {
                    var html = "";
                    if (dataItem.ServerGroupId !== 1) {
                        html += '<a class="btn btn-sm btn-info btn-unlink-item" href="#"><i class="fa fa-chain-broken "></i>&nbsp;Unlink</a>&nbsp;';
                    }
                    if (dataItem.LoginTypeName == 'V6') {
                        html += "<a class=\"btn btn-sm btn-success btn-v6-login\" data-ipaddress=\"".concat(dataItem.IpAddress, "\" href=\"#\"><i class=\"fa fa-lock \"></i>&nbsp;Login</a>&nbsp;");
                    }
                    else {
                        html += '<a class="btn btn-sm btn-success btn-login" target="_blank" href="/Servers/MultipleLogin?url=' + dataItem.IpAddress + '"><i class="fa fa-lock "></i>&nbsp;Login</a>&nbsp;';
                    }
                    html += '<a class="btn btn-sm btn-yellow btn-detail" href="/ServersGroups/Details/' + dataItem.Id + '"><i class="fa fa-edit "></i>&nbsp;View</a>';
                    if (UserContext.hasAccess("Admin,Servers.Delete")) {
                        html += '&nbsp;<button class="btn btn-sm btn-danger btn-remove-item" href="#"><i class="fa fa-trash-o "></i>&nbsp;Delete</button>';
                    }
                    return '<div class="text-right">' + html + "</div>";
                }
            });
        };
        ServersGroups.prototype.initGroups = function () {
            var _this = this;
            var self = this;
            var gridId = "divSGTable";
            var gridStructure = self.lookupLists.GridStructures.ServerGroupStructure;
            var columns = gridStructure.columns;
            self.groupsTable = new KendoUtils.KendoUtils();
            var gridOptions = {
                dataSourceOptions: {
                    transport: {
                        read: {
                            url: "/ServersGroups/GetGroups",
                            type: "POST",
                            data: function () {
                                var data = {};
                                if (self.filterByAny()) {
                                    data.filterText = self.filterByAny();
                                }
                                return data;
                            },
                            dataType: "json"
                        }
                    }
                },
                gridOptions: {
                    toolbar: kendo.template($("#sg-toolbar-template").html()),
                    columns: columns,
                    autoBind: true,
                    resizable: true,
                    reorderable: true,
                    //mobile: true,
                    scrollable: true,
                    columnMenu: true,
                    filterable: {
                        mode: "row",
                        extra: false
                    },
                    detailInit: self.initServers.bind(self),
                    dataBound: function (e) {
                        self.clearFilterInProgress = false;
                        var gridData = e.sender;
                        $.each(gridData.tbody.find("tr.k-master-row"), function () {
                            var rowData = gridData.dataItem(this);
                            if (self.contains(self.expandedItemIDs, rowData.Id)) {
                                gridData.expandRow(this);
                            }
                        });
                    },
                    detailExpand: function (e) {
                        var rowData = e.sender.dataItem(e.masterRow);
                        if (!self.contains(self.expandedItemIDs, rowData.Id)) {
                            self.expandedItemIDs.push(rowData.Id);
                        }
                    },
                    detailCollapse: function (e) {
                        var rowData = e.sender.dataItem(e.masterRow);
                        for (var i = 0; i < self.expandedItemIDs.length; i++) {
                            if (self.expandedItemIDs[i] === rowData.Id)
                                self.expandedItemIDs.splice(i, 1);
                        }
                    }
                },
                enableExport: {
                    entityName: "ServerGroup",
                    title: "Servers Groups Records",
                    enablePdf: false
                },
                allowBulkEdits: {
                    enabled: false
                },
                autoHeight: {
                    totalOffset: 46 + 41 + 3
                },
                gridId: gridId,
                showPagerOnTop: false,
                controller: self
            };
            self.groupsTable.initGrid(gridOptions);
            self.filterByAny.extend({ rateLimit: 200 }).subscribe(function () {
                if (!self.clearFilterInProgress) {
                    self.groupsTable.refresh();
                }
            });
            $("#" + gridId + " tbody").on("click", ".btn-edit", function (event) {
                var data = KendoUtils.KendoUtils.getGridRowDataItem(event.currentTarget);
                self.editGroup(data.Id);
                event.preventDefault();
            }).on("click", ".btn-add", function (event) {
                var data = KendoUtils.KendoUtils.getGridRowDataItem(event.currentTarget);
                self.serverActions.linkServer(data.Id, data.ServerGroupName);
                event.preventDefault();
            }).on("click", ".btn-remove", function (event) {
                var data = KendoUtils.KendoUtils.getGridRowDataItem(event.currentTarget);
                self.deleteGroupConfirm(data);
                event.preventDefault();
            }).on("click", ".btn-remove-item", function (event) {
                var data = KendoUtils.KendoUtils.getGridRowDataItem(event.currentTarget);
                self.serverActions.deleteServerConfirm(data.Id, data.IpAddress);
                event.preventDefault();
            }).on("click", ".btn-edit-item", function (event) {
                var data = KendoUtils.KendoUtils.getGridRowDataItem(event.currentTarget);
                self.serverActions.editServer(data.Id);
                event.preventDefault();
            }).on("click", ".btn-unlink-item", function (event) {
                var data = KendoUtils.KendoUtils.getGridRowDataItem(event.currentTarget);
                self.serverActions.unlinkServerConfirm(data.Id, data.IpAddress);
                event.preventDefault();
            }).on("click", ".btn-v6-login", function (event) {
                var ipaddress = $(event.currentTarget).data('ipaddress');
                self.serverActions.loginToServer(ipaddress, null);
                event.preventDefault();
            });
            self.serverActions.deleteCallback = function () {
                _this.groupsTable.refresh();
            };
        };
        ServersGroups.prototype.initServers = function (e) {
            var self = this;
            var gridStructure = self.lookupLists.GridStructures.ServersStructure;
            var grid = $("<div/>").appendTo(e.detailCell).kendoGrid({
                dataSource: {
                    data: e.data.Servers,
                    serverPaging: false,
                    serverSorting: false,
                    serverFiltering: false,
                    pageSize: 100,
                    schema: {
                        model: gridStructure.model
                        //data: response => response.Data,
                        //total: "Total"
                    }
                },
                scrollable: true,
                resizable: true,
                sortable: true,
                pageable: true,
                columns: gridStructure.columns,
                dataBound: function (e) {
                }
            });
            var autoWidthRunner = 0;
            $(window).resize(function () {
                autoWidthRunner = self.groupsTable.resizeAutoWidthRunner(grid, autoWidthRunner);
            });
            autoWidthRunner = self.groupsTable.resizeAutoWidthRunner(grid, autoWidthRunner);
        };
        ServersGroups.prototype.exportTo = function () {
            var self = this;
            self.groupsTable.exportTo();
        };
        ServersGroups.prototype.clearFilter = function () {
            var _this = this;
            var self = this;
            self.clearFilterInProgress = true;
            self.filterByAny("");
            setTimeout(function () {
                _this.groupsTable.refresh();
            }, 201);
        };
        ServersGroups.prototype.deleteGroupConfirm = function (group) {
            var self = this;
            if (group.Id === 1) {
                tools.error("'Default' group can not be deleted");
                return;
            }
            if (group.Servers && group.Servers.length > 0) {
                tools.error("Not empty group can not be deleted");
                return;
            }
            tools.confirmModal({
                title: "Delete Server Group: " + group.ServerGroupName,
                text: "Are you sure you want to delete Server Group?",
                buttonTitle: "Delete",
                type: "danger",
                modalOptions: {}
            }, function (modal) {
                $(modal).modal("hide");
                self.deleteGroup(group.Id);
            });
        };
        ServersGroups.prototype.deleteGroup = function (groupId) {
            var self = this;
            if (groupId === 1) {
                tools.error("'Default' group can not be deleted");
                return;
            }
            var data = {
                id: groupId
            };
            data["__RequestVerificationToken"] = $('#mainAntiForgeryTokenForm input[name="__RequestVerificationToken"]').val();
            tools.ajaxPost({
                url: "/ServersGroups/DeleteGroupConfirmed",
                data: data
            }).done(function (result) {
                if (result.Success) {
                    tools.success("Server Group deleted successfully");
                    self.groupsTable.refresh();
                }
                else {
                    tools.error(result.Error);
                }
            }).always(function () {
                //btn.button("reset");
            });
        };
        ServersGroups.prototype.editGroup = function (groupId) {
            var self = this;
            var title = "Add New Server Group";
            if (!isNaN(groupId)) {
                title = "Edit Server Group";
            }
            tools.editModal({
                title: title,
                buttonTitle: "Save",
                type: "info",
                modalOptions: {},
                save: function (event, modal) {
                    //validate form
                    if (!self.editModel().ServerGroupName()) {
                        tools.error("Group Name is required");
                        return;
                    }
                    $(event.currentTarget).button("loading");
                    self.saveGroup(event.currentTarget, modal);
                },
                opened: function (modal) {
                    var getModelCall = null;
                    if (!isNaN(groupId)) {
                        getModelCall = tools.ajaxGet({
                            url: "/ServersGroups/GetGroupById",
                            data: { id: groupId },
                            success: function (result) {
                                if (result.Success) {
                                    self.editModel(new ServerGroupModel(result.Data));
                                }
                                else {
                                    log.error(result.Error);
                                }
                            }
                        });
                    }
                    else {
                        self.editModel(new ServerGroupModel());
                    }
                    $.when(getModelCall).done(function () {
                        $(modal).find(".modal-body").html("<div data-bind=\"template: { name: 'sg-group-edit-template', data: editModel }\"></div>");
                        ko.applyBindings(self, modal);
                    });
                }
            });
        };
        ServersGroups.prototype.saveGroup = function (btn, modal) {
            var _this = this;
            var self = this;
            var obj = ko.mapping.toJS(self.editModel);
            obj["__RequestVerificationToken"] = $('#mainAntiForgeryTokenForm input[name="__RequestVerificationToken"]').val();
            tools.ajaxPost({
                url: "/ServersGroups/SaveGroup",
                data: obj
            }).done(function (result) {
                if (result.Success) {
                    tools.success("Changes updated successfully");
                    _this.groupsTable.refresh();
                    $(modal).modal("hide");
                    return;
                }
                else {
                    tools.error(result.Error);
                }
            }).always(function () {
                $(btn).button("reset");
            });
        };
        ServersGroups.prototype.editServer = function () {
            var self = this;
            self.serverActions.editServer();
        };
        ServersGroups.prototype.contains = function (a, obj) {
            for (var i = 0; i < a.length; i++) {
                if (a[i] === obj)
                    return true;
            }
            return false;
        };
        ServersGroups.prototype.showLogs = function () {
            if (UserContext.hasAccess("Admin")) {
                var dataLogs = new DataLogs("ServerGroup");
                dataLogs.open("Server Groups logs");
                event.preventDefault();
            }
        };
        return ServersGroups;
    }());
    setTimeout(function () {
        if (urls_1.urls.startsWith("/ServersGroups/Index")) {
            log.log("Initialize ServersGroups");
            $(function () {
                (new ServersGroups()).init();
            });
        }
    }, 0);
    return ServersGroups;
});
//# sourceMappingURL=serversGroups.js.map


//////////////////
// WEBPACK FOOTER
// ./build/areas/serversGroups/serversGroups.js
// module id = 267
// module chunks = 2